module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enabled":"Available for installation","disabled":"Not available for installation"},"ru":{"enabled":"Доступные для установки","disabled":"Недоступные для установки"},"ua":{"enabled":"Доступні для встановлення","disabled":"Недоступні для встановлення"}}')
  delete Component.options._Ctor
}
